import { Component, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from './services/auth.service';
import { LoadingService } from './services/loading.service';
import { SidenavService } from './services/sidenav.service';
import { ReCaptchaService } from './services/recaptcha.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(
        public loading: LoadingService,
        public sidenav: SidenavService,
        public auth: AuthService,
        private title: Title,
        private el: ElementRef,
        private recaptcha: ReCaptchaService
    ) {
    }
    userData = this.auth.userData || {};

    isLoggedIn(): boolean {
        return this.auth.isLoggedIn();
    }

    authLogout(): void {
        this.auth.logout(false, true);
    }

    ngOnInit(): void {
        if (this.isLoggedIn()) {
            this.title.setTitle('Home | MFGM-CMS');
        } else {
            this.title.setTitle('Login | MFGM-CMS');
        }

        this.el.nativeElement.removeAttribute("ng-version");

        (document as any).fonts.ready.then(() => {
            document.documentElement.classList.add('fonts-loaded');
        });

        this.recaptcha.loadScriptIfNeeded();
    }

    ngAfterViewInit(): void {
        this.userData = this.auth.userData;
    }

}
